import { gql } from "@apollo/client";
import GraphQlService from "./graphql";

class journalAccessGraphql extends GraphQlService {
  async getAllJournalTypes(userId = null, accountId = null) {
    return this.client
      .query({
        query: gql`
          query {
            getAllJournalByCurrentUser(
                userId: ${userId === null ? null : `"${userId}"`}, 
                accountId: ${accountId === null ? null : `"${accountId}"`}
              ) {
              id
              nameSw
              nameEng
              public
              createdAt
              updatedAt
            }
          }
        `,
      })
      .then((result) => result?.data?.getAllJournalByCurrentUser);
  }

  async createJournalFolderAccess(userId, accountId, journalTypeIds) {
    return this.client
      .mutate({
        mutation: gql`
          mutation {
            createJournalFolderAccess(createJournalFolderAccessInput: {
              userId: "${userId}"
              accountId: "${accountId}"
              journalTypeIds: ${JSON.stringify(journalTypeIds)}
            }) {
              id
              createdAt
              updatedAt
              version
              journalType {
                id
                nameSw
                nameEng
                public
              }
              user {
                id
              }
              account {
                id
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.createJournalFolderAccess);
  }

  async updateJournalFolderAccess(userId, accountId, journalTypeIds) {
    return this.client
      .mutate({
        mutation: gql`
          mutation {
            updateJournalFolderAccess(updateJournalFolderAccessInput: {
              userId: "${userId}"
              accountId: "${accountId}"
              journalTypeIds: ${JSON.stringify(journalTypeIds)}
            }) {
              id
              createdAt
              updatedAt
              version
              journalType {
                id
                nameSw
                nameEng
                public
              }
              user {
                id
              }
              account {
                id
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.updateJournalFolderAccess);
  }
}

const journalAccessGraphqlInstance = new journalAccessGraphql();
export default journalAccessGraphqlInstance;
